import React, { useState } from "react";
import { Form, Input } from "antd";
import axios from "axios";
import { MailOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  SuccessMessage,
  ErrorMessage,
} from "../../components/Messages/messages";
import { Loading } from "../../components/Loading/Loading";
import "./Auth.css";
import API_BASE_URL from "../../config";

export const ForgotPassword = (props) => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [emailSent, setEmailSent] = useState(false);

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const onFinish = async (e) => {
    window.scrollTo(0, 0);
    setLoading(true);
    await axios
      .post(`${API_BASE_URL}/api/users/forgot-password`, { email })
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          SuccessMessage(res.data.successMessage);
          setEmailSent(true);
          setTimeout(() => {
            props.history.push("/reset-password", { email });
          }, 2000);
        } else if (res.status === 404) {
          ErrorMessage(res.data.errorMessage);
        } else {
          ErrorMessage(res.data.errorMessage);
        }
      })
      .catch((error) => {
        setLoading(false);
        if (error.response && error.response.data) {
          ErrorMessage(error.response.data.errorMessage);
        } else {
          ErrorMessage("An error occurred. Please try again.");
        }
      });
  };

  return (
    <div>
      <Helmet>
        <title>Forgot Password</title>
      </Helmet>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="auth">
            <div className="auth-inner text-center inherit-background">
              <div className="header">
                <Link className="apply-teko" to="/">
                  Cost Advisor
                </Link>
                <h3 className="apply-teko"> Forgot Password </h3>
                <p className="text-white mt-3">
                  Enter your email address and we'll send you a code to reset
                  your password.
                </p>
              </div>
              <Form
                name="basic"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                className="p-4 custom-form"
              >
                <div className="floating-label-group input-box">
                  <Form.Item
                    name="email"
                    rules={[
                      {
                        type: "email",
                        message:
                          "The provided input is not a valid email address.",
                      },
                      {
                        required: true,
                        message: "Please enter your email.",
                      },
                    ]}
                  >
                    <Input
                      name="email"
                      onChange={handleChange}
                      size="small"
                      placeholder="Email"
                      prefix={<MailOutlined />}
                    />
                  </Form.Item>
                </div>
                <div className="submit-btn-container">
                  <button
                    type="submit"
                    className="btn my-2 mt-3 mb-5 signup-btn"
                    disabled={emailSent}
                  >
                    Send Reset Code
                  </button>
                </div>
              </Form>
              <div>
                <p className="custom-form">
                  Remember your password?
                  <br></br>
                  <Link to="/login" className="pass">
                    Back to Login
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
